import { jsx as r } from "react/jsx-runtime";
import { useRef as g, useState as c, useEffect as m } from "react";
import { c as i } from "../clsx-OuTLNxxd.js";
import { T as _, b as C, h as p, g as B, a as y, d as f, c as j, e as v } from "../Table-DPiuN8_d.js";
import '../GridTable.css';const h = "_gridTableWrapper_1evuj_274", N = "_gridTable_1evuj_274", R = "_gridTableRow_1evuj_284", W = "_gridTableColumn_1evuj_288", G = "_gridTableCaption_1evuj_291", M = "_gridTableHeader_1evuj_292", w = "_gridTableBody_1evuj_293", F = "_gridTableFooter_1evuj_294", H = "_gridTableCell_1evuj_298", x = "_fullWidthMobile_1evuj_301", E = "_hasMultipleTableBodies_1evuj_310", O = "_mainColumn_1evuj_345", o = {
  gridTableWrapper: h,
  gridTable: N,
  gridTableRow: R,
  gridTableColumn: W,
  gridTableCaption: G,
  gridTableHeader: M,
  gridTableBody: w,
  gridTableFooter: F,
  gridTableCell: H,
  fullWidthMobile: x,
  hasMultipleTableBodies: E,
  mainColumn: O
}, d = ({ children: e, className: l, label: a, mobileColumns: s, ...n }) => {
  const t = g(null), [b, T] = c(1);
  return m(() => {
    if (t.current) {
      const u = t.current.getElementsByClassName(o.gridTableBody);
      T(u.length);
    }
  }, []), /* @__PURE__ */ r(
    "div",
    {
      "aria-label": a,
      className: o.gridTableWrapper,
      "data-cxy-name": "grid-table",
      style: {
        "--gridWidth": b + 1,
        ...b === 1 ? { gridTemplateColumns: "auto" } : {},
        "--mobileColumns": s
      },
      children: /* @__PURE__ */ r(
        _,
        {
          className: i(o.gridTable, l, {
            [o.hasMultipleTableBodies]: b > 1
          }),
          ref: t,
          ...n,
          children: e
        }
      )
    }
  );
}, S = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(p, { className: i(o.gridTableRow, l), ...a, children: e }), k = ({ children: e, className: l, isMain: a, ...s }) => /* @__PURE__ */ r(
  f,
  {
    className: i(
      o.gridTableColumn,
      {
        [o.mainColumn]: a
      },
      l
    ),
    ...s,
    children: e
  }
), q = ({
  children: e,
  className: l,
  isFullWidthMobile: a,
  isMain: s,
  order: n,
  start: t,
  ...b
}) => /* @__PURE__ */ r(
  j,
  {
    className: i(
      o.gridTableCell,
      {
        [o.fullWidthMobile]: a,
        [o.mainColumn]: s
      },
      l
    ),
    style: { "--cellOrder": n, "--start": t },
    ...b,
    children: e
  }
), z = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(v, { ...a, className: i(o.gridTableFooter, l), children: e }), A = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(B, { ...a, className: i(o.gridTableHeader, l), children: e }), D = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(y, { className: i(o.gridTableBody, l), ...a, children: e }), I = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(C, { className: i(o.gridTableCaption, l), ...a, children: e });
d.Caption = I;
d.Row = S;
d.Head = A;
d.Body = D;
d.Column = k;
d.Cell = q;
d.Footer = z;
export {
  d as GridTable
};
